<script lang="ts">
  import Image from "@components/Image.svelte"
  import IntersectionObserver from "@objects/IntersectionObserver.svelte"
  import type { AdUnit } from "@shared/models/AdUnit/AdUnit"
  import { trackAdUnitIntersection, trackAdUnitClick } from "@helpers/adInteraction"
  import i18n from "@/store/i18n"

  export let adUnit: AdUnit
</script>

<IntersectionObserver
  class="relative bg-beige-50 max-w-[400px] w-full"
  on:intersect={() => trackAdUnitIntersection(adUnit)}
>
  <a class="block h-full p-4 pb-8" on:click={() => trackAdUnitClick(adUnit)} href={adUnit.content?.destination_url}>
    <Image src={adUnit.image?.url} width={350} fit="cover" alt={adUnit.content?.title} />

    <h1 class="mt-4 font-heading text-2xl line-clamp-2 tracking-tight">
      {adUnit.content?.title}
    </h1>

    <p class="text-wrap">
      {adUnit.content?.tagline}
    </p>

    <span class="inline-block mt-2">{adUnit.content?.cta_text}</span>
    <span class="absolute bottom-2 right-2 text-xs"
      >{$i18n.t("components.AdUnit.CategoryMenuContentCard.sponsored")}</span
    >
  </a>
</IntersectionObserver>
